import $ from "jquery";

export function getParentsUntil(element, criteria, until) {
  let results = $(element).parentsUntil(until);
  results = results.filter(criteria);
  return results;
}
